/**
 * Diaper UI's bound AppSwitcher.
 *
 * URLs come from `getNovaEnv()` / `getAppUrl()` (runtime, BFF-injected in
 * prod; `REACT_APP_*` in dev). The shared AppSwitcher itself filters by JWT
 * `apps` claim (only apps the current user has a grant for show up).
 */
import React from 'react';
import { AppSwitcher as SharedAppSwitcher, AppDescriptor, getAppUrl } from '@nova-integration/ui-shared';
import { useAuthStore } from '../stores/authStore';
import { APP_ID } from '../lib/capabilities';

const buildApps = (): AppDescriptor[] => {
  const opsUrl = getAppUrl('ops-ui', APP_ID);
  const diaperUrl = getAppUrl('diaper-ui', APP_ID);
  const identityUrl = getAppUrl('identity', APP_ID);
  return [
    { id: 'ops-ui', label: 'Ops', url: opsUrl },
    { id: 'diaper-ui', label: 'Diaper / Sessions', url: diaperUrl },
    { id: 'identity', label: 'Identity Admin', url: identityUrl ? `${identityUrl}/admin-ui/` : '' },
  ].filter((a) => a.url) as AppDescriptor[];
};

export const AppSwitcher: React.FC = () => {
  const apps = React.useMemo(buildApps, []);
  return <SharedAppSwitcher apps={apps} currentAppId={APP_ID} useAuthStore={useAuthStore} />;
};
